
import CustomSelect from '../../../form/custom-select';
import {
    // initFlatCardOptions,
    initFlatTicket
} from '../../../../common/scripts/common';
import Observer from '../../../../common/scripts/observer';
import tmplFlatsList from '../flat/templates/flat-list.twig';
import {Utils} from '../../../../common/scripts/utils';

const observer = new Observer();

class ParametricResult {
    constructor(options) {
        /**
         * Параметры
         */
        this.options = options;

        /**
         * Целевой элемент
         */
        this.element = options.element ? options.element.querySelector('.j-parametric-result') : null;

        /**
         * CSS-класс состояния загрузки
         * @type {string}
         */
        this.loadingClass = 'is-loading';
        this.activeClass = 'is-active';
        this.disableClass = 'is-disabled';
        this.processClass = 'is-process';
        this.fixedClass = 'is-fixed';
        this.debTime = 150;
        this.total = this.element.querySelector('.j-parametric-result-total');
        this.promotions = null;
        this.shownPromos = 0;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._bindContext();
        this._initElements();
        this._initSelects();
        this._bindEvents();
        this._initTooltips();
        this._countPromos();
    }

    /**
     * Проверяем, есть ли промо-баннера на странице
     */
    _countPromos() {
        const promos = Array.from(document.querySelectorAll('.j-flat-ticket-promotion'));

        this.shownPromos = promos.length;
    }

    /**
     * Запуск состояния загрузки
     */
    runLoading() {
        this.element.classList.add(this.loadingClass);
    }

    /**
     * Отмена состояния загрузки
     */
    stopLoading() {
        this.element.classList.remove(this.loadingClass);
    }

    /**
     * Обновляет результаты выдачи после поиска
     * @param {object} data - данные с сервера
     */
    setResult(data) {
        this._setNoResults(data.noResults ? data.noResults : false);
        this._setPromotions(data.promotions);
        this.setFlatsList(data.flats, true);
        this.setTotal(data.total);
        this.setMoreButton(data.more);
    }

    _setNoResults(noResults) {
        this.noResults?.classList.toggle(this.activeClass, noResults);
        this.resultsWrapper?.classList.toggle(this.disableClass, noResults);
    }

    _setPromotions(promotions) {
        if (!promotions || promotions.length === 0) {
            return;
        }

        this.promotions = promotions;
    }

    /* eslint-disable max-statements */
    setFlatsList(flats, isReplace = false) {
        if (!flats || !flats.length) {
            return;
        }

        if (isReplace) {
            Utils.clearHtml(this.flatsList);
        }

        this._countPromos();

        if (flats.length > 8 && this.promotions && this.promotions.length) {
            // Получаем количество раз вставки баннера - плюсуем 1, т.к.
            // Math.floor будет округлять в меньшую сторону
            const countPromo = Math.floor(flats.length / 12) + 1;

            for (let i = 0; i < countPromo; i++) {
                // Порядковый номер баннера
                // eslint-disable-next-line
                const promoNum = this.shownPromos < this.promotions.length ? this.shownPromos : this.shownPromos % this.promotions.length;

                // Проверяем - полная ли линия с промобаннером, если нет, ставим его предпоследним
                const fullLine = flats.length - (11 * (i + 1)) >= 0;

                if (fullLine) {
                    // Высчитываем позицию, 9 - стартовая позиция баннера на
                    // первой линии, все следующие смещены на 12 элементов
                    const position = 9 + (12 * i);

                    flats.splice(position, 0, this.promotions[promoNum]);
                } else {
                    flats.splice(flats.length - 1, 0, this.promotions[promoNum]);
                }

                this.shownPromos = this.shownPromos + 1;
            }
        }

        flats.forEach((item) => {
            if (!item.promotion) {
                item.price.current = Utils.convertToDigit(Math.ceil(Number(item.price.current)));

                if (item.price.old) {
                    item.price.old = Utils.convertToDigit(Math.ceil(Number(item.price.old)));
                }

                if (item.price.mortgage) {
                    item.price.mortgage = Utils.convertToDigit(Math.ceil(Number(item.price.mortgage)));
                }

                if (item.price.meter) {
                    item.price.meter = Utils.convertToDigit(Math.ceil(Number(item.price.meter)));
                }

                if (item.price.start) {
                    item.price.start = Utils.convertToDigit(Math.ceil(Number(item.price.start)));
                }
            }
        });

        Utils.insetContent(this.flatsList, tmplFlatsList({flats}));
        this._bindCardsEvents();
        observer.publish('parametric:updateFlats', this);

        // Проверяем - если активна табличная верстка - применяем стили к результатам фильтрации
        if (this.tableTitle.classList.contains(this.activeClass)) {
            observer.publish('flatsList:table');
        }

        this._initTooltips();
    }
    /* eslint-enable max-statements */

    /**
     * Устанавливает новые данные в блок "Показать ещё"
     * @param {Object} more - объект с данными о количестве квартир
     */
    setMoreButton(more) {
        if (!this.moreButton) {
            return;
        }

        this.moreButton.classList.toggle(this.disableClass, !more || !more.enable);

        if (more?.count) {
            this.moreButton.dataset.shown = more.count;
        }

        if (more && this.moreButtonText && more.text) {
            this.moreButtonText.innerHTML = more.text;
        }
    }

    /**
     * Дополняет список квартир (Показать ещё)
     * @param {object} data - данные с сервера
     * @param {boolean} clear - надо ли очищать предыдущий результат
     */
    setMoreResult(data, clear = false) {
        this._setPromotions(data.promotions);
        this.setFlatsList(data.flats, clear);
        this.setMoreButton(data.more);
    }

    /**
     * Устанавливает найденное количество квартир
     * @param {string} data - найденное количество квартир
     */
    setTotal(data) {
        if (data && this.total) {
            this.total.innerText = data;
        }
    }

    scrollToTop() {
        this.element.scrollIntoView({
            behavior: 'smooth'
        });
    }

    _bindContext() {
        this._showMore = this._showMore.bind(this);
        this._collectData = this._collectData.bind(this);
    }

    /**
     * Инициализация элементов выдачи
     * @private
     */
    _initElements() {
        // Общий враппер для контентной части параметрического - если есть результат выборки
        this.resultsWrapper = this.element.querySelector('.j-parametric-result__wrapper');
        // Враппер со списком квартир
        this.flatsList = this.element.querySelector('.j-parametric-result__content');
        // Кнопка "Показать все варианты"
        this.resetBtn = this.element.querySelector('.j-parametric-result__reset');
        // Инпуты сортировки
        this.sortInputs = Array.from(this.element.querySelectorAll('.j-parametric-result__sort input'));

        const sortDefault = this.sortInputs.find((item) => {
            return item.checked;
        });

        this.sort = sortDefault ? sortDefault.value : null;

        // Кнопки смены вида
        this.viewButtons = Array.from(this.element.querySelectorAll('.j-parametric-result__view'));
        // Заголовок таблицы
        this.tableTitle = this.element.querySelector('.j-parametric-result__table-head');
        // Показать ещё
        this.moreButton = this.element.querySelector('.j-parametric-result__more');

        this.moreButtonText = this.moreButton ?
            this.moreButton.querySelector('.j-parametric-result__more-text') :
            null;
        // Враппер отсутствия результатов
        this.noResults = this.element.querySelector('.j-parametric-result__nothing');

        // Элементы с тултипами - цена
        this.pricePins = [];
        // Элементы с тултипами - акция
        this.salePins = [];
    }

    /**
     * Инитит подсказки для мобил, чтобы появлялись по клику
     * @private
     */
    _initTooltips() {
        this.salePins = [...document.querySelectorAll('.j-sale-pin__info')];
        this.pricePins = [...document.querySelectorAll('.j-pin__info')];

        if (this.salePins.length > 0) {
            this.salePins.forEach((pin) => {
                pin.classList.remove('is-active');

                if (!pin.hasAttribute('data-init')) {
                    pin.setAttribute('data-init', 'true');

                    pin.addEventListener('click', (event) => {
                        if (!Utils.isMobile()) {
                            return;
                        }

                        event.preventDefault();
                        pin.classList.toggle('is-visible');
                    });
                }
            });
        }

        if (this.pricePins.length > 0) {
            this.pricePins.forEach((pin) => {
                if (!pin.hasAttribute('data-init')) {
                    pin.setAttribute('data-init', 'true');
                }

                pin.classList.remove('is-active');

                pin.addEventListener('click', (event) => {
                    if (!Utils.isMobile()) {
                        return;
                    }

                    event.preventDefault();

                    pin.classList.toggle('is-active');
                });
            });
        }
    }

    _initSelects() {
        this.selectElements = Array.from(this.element.querySelectorAll('.j-parametric-result__sort'));
        this.selects = [];
        this.selectElements.forEach((element) => {
            // делаем чтобы окно сортировки не закрывалось по клику на направление сортировки
            // в мобильной версии
            if (Utils.isMobile()) {
                element.classList.remove('is-single');
            }

            const select = new CustomSelect({
                elem: element
            });

            select.init();
            this.selects.push(select);
        });
    }

    /**
     * Отправляет данные на сервер
     * @param {String} type - тип отправки
     * @param {Object} data - данные для отправки
     * @private
     */
    _send(type, data = {}) {
        if (!type) {
            return;
        }

        switch (type) {
            case 'sort':
                if (this.options.changeSort) {
                    this.options.changeSort(data);
                }
                break;
            case 'more':
                if (this.options.clickMore) {
                    this.options.clickMore(data);
                }
                break;
            case 'booked':
                if (this.options.hideBooked) {
                    this.options.hideBooked(data);
                }
                break;
            default:
                break;
        }
    }

    _bindEvents() {
        this.sortInputs.forEach((sortInput) => {
            sortInput.addEventListener('change', (event) => {
                this.sort = event.target.value;
                this._send('sort', this._collectData());
            });
        });

        this.viewButtons.forEach((viewButton, index) => {
            viewButton.addEventListener('click', () => {
                if (Utils.isMobile()) {
                    if (viewButton.classList.contains('is-active')) {
                        const newView = index === 0 ? this.viewButtons[1] : this.viewButtons[0];

                        this._setView(newView);
                    }
                } else {
                    this._setView(viewButton);
                }
            });
        });

        if (this.moreButton) {
            this.moreButton.addEventListener('click', this._showMore);
        }

        this._bindCardsEvents();

        // залипающая шапка в десктопном табличном представлении параметрического
        document.addEventListener('scroll', () => {
            setTimeout(() => {
                if (this.tableTitle && this.flatsList) {
                    if (this.flatsList.getBoundingClientRect().y < 10) {
                        if (!this.tableTitle.classList.contains(this.fixedClass)) {
                            this.tableTitle.classList.add(this.fixedClass);
                        }
                    } else {
                        this.tableTitle.classList.remove(this.fixedClass);
                    }
                }
            }, 500);
        });
    }

    _bindCardsEvents() {
        const showMoreButtons =
            Array.from(this.element.querySelectorAll('.j-parametric-card__show-more:not([data-init])'));

        showMoreButtons.forEach((showMoreBtn) => {
            showMoreBtn.addEventListener('click', (event) => {
                event.preventDefault();
            });
            showMoreBtn.setAttribute('data-init', 'true');
        });

        observer.publish('favorite:reInit');

        // initFlatCardOptions();
        initFlatTicket();
    }

    /**
     * Меняет вид вывода результатов
     * @param {HTMLElement} button - кнопка, на которую нажали
     * @private
     */
    _setView(button) {
        const view = button.dataset.view;
        const promo = Array.from(this.flatsList.querySelectorAll('.j-flat-ticket-promotion'))[0];
        const flatListElements = Array.from(this.flatsList.querySelectorAll('a'));
        const flatCount = flatListElements.length;

        this.viewButtons.forEach((viewButton) => {
            const method = button === viewButton ? 'add' : 'remove';

            viewButton.classList[method](this.activeClass);
        });

        this.flatsList.classList.add(this.processClass);
        this.flatsList.classList.toggle('parametric-result__flats_view_table', view === 'table');
        this.flatsList.classList.toggle('j-parametric-result__content-table', view === 'table');
        this.tableTitle.classList.toggle('is-active', view === 'table');

        // если табличный вью, передаем событие для включения анимации опций в карточке и переставляем промо-блок
        view === 'table' ? observer.publish('flatsList:table') : observer.publish('flatsList:tile');

        if (view === 'table' && promo) {
            if (flatCount > 3 && flatCount < 5) {
                flatListElements[2].after(promo);
            } else if (flatCount >= 5) {
                flatListElements[3].after(promo);
            }
        } else if (promo) {
            // если плиткой вью, передаем событие для выключения анимации опций в карточке и переставляем промо-блок

            if (flatCount > 2 && flatCount < 6) {
                flatListElements[1].after(promo);
            } else if (flatCount >= 6) {
                flatListElements[6].after(promo);
            }
        }

        setTimeout(() => {
            this.flatsList.classList.remove(this.processClass);
        }, 0);
    }

    /**
     * Показать ещё
     * @private
     */
    _showMore() {
        this._send('more', this._collectData());
    }

    _collectData() {
        const data = {};

        this._addSort(data);
        this._addLimit(data);

        return data;
    }

    /**
     * Добавляет сортировку в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addSort(data) {
        data.sort = this.sort;
    }

    /**
     * Добавляет количество выведенных квартир в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addLimit(data) {
        if (!this.moreButton) {
            return;
        }

        data.shown = this.moreButton.dataset.shown;
    }
}

export default ParametricResult;
